import { z } from 'zod';

export interface Participant {
  id: number;
  full_name: string;
  cpf: string;
  address: string;
  city: string;
  postal_code: string;
  phone: string;
  email: string;
  status?: string;
  created_at: string;
  updated_at: string;
}

export interface ParticipantFilterOptions {
  full_name?: string;
  cpf?: string;
  city?: string;
  phone?: string;
  email?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface ParticipantResponse {
  data: Participant[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export const participantSchema = z.object({
  full_name: z.string().min(1, 'Nome completo é obrigatório'),
  cpf: z.string().min(1, 'CPF é obrigatório'),
  address: z.string(),
  city: z.string(),
  postal_code: z.string(),
  phone: z.string(),
  email: z.string().email('Email inválido').optional(),
});
